module.exports = __webpack_public_path__ + "img/security-shield.0b382917.svg";